
export default class FrameUtils 
{
    static getFirstNode( nodes )
    {
        if( nodes!==undefined && nodes.length>0 )
        {
            for(let i=0; i<nodes.length; i++)
            {
                if( nodes[i].path!==undefined && nodes[i].path!==null)
                {
                    return nodes[i];
                }
                
                if( nodes[i].subcomponents!==undefined )
                {
                    return this.getFirstNode(nodes[i].subcomponents);
                }
            }

            return null;
        }

        return null;
    }
}
